const keyPattern = /\w+_\w+/;

export default {
  get(key, defaultValue = null) {
    let res = localStorage.getItem(key);
    try {
      res = JSON.parse(res);
    } catch (e) {
      console.log(e);
    }
    return res || defaultValue;
  },
  set(key, value) {
    if (!keyPattern.test(key)) {
      console.log(`${key} 应该以 应用[前缀_${key}] 的形式展示，例如 study_${key}`);
    }
    localStorage.setItem(key, JSON.stringify(value));
  },
};
